/*-------------------------------------------------------------------*/
/*									賞味期限の作成&エディット												*/
/*											#skt_total_zaikoがなければ実行されない				*/
/*--------------------------------------------------------------------*/
$(function(){

	var path_org = 'https://www.tirakita.com/syssyssyssyssyssyssyssyssyssys/syoumi_kigen_edit_ajax.php?';


	//要素がなければ実行しない
	if($('#skt_total_zaiko').length || $('#cosme_skt_total_zaiko').length){
		//数が足りてるかチェック
		var chk_num = function(){
			var new_zaiko = 0;
			$('.dke_zaiko').each(function(){
				new_zaiko += parseInt($(this).val());
			});
			var zaiko = parseInt($('#skt_total_zaiko').val());
			if(isNaN(zaiko)){ zaiko = parseInt($('#cosme_skt_total_zaiko').val()); }

			if(new_zaiko != zaiko){
				$('#skt_error_disp').html('<span style=\'color:#F00;\'>在庫数:'+zaiko+'個に対して、賞味期限在庫は'+new_zaiko+'個です。</span>');
				return;
			}
			$('#skt_error_disp').html('');
		}

		//共通Ajax読み込みルーチン
		var call_func = function(mode,selector){
			chk_num();	//数が足りてるかチェック

			var id = selector.data('id');
			var val = selector.val();

			var path = path_org+'mode='+mode+'&id='+id+'&val='+val;
			$.get(path,function(data) {
				selector.val(data);
				//更新が完了したらボーダーを光らせるアニメ
				if(val == data){
					selector.css('border','2px solid #00F');
					$({alpha:1}).animate({alpha:0}, {
						duration: 1000,
						step: function(){
							selector.css('border-color','rgba(130,191,255,'+this.alpha+')');
						}
					});
				}
			});
		};

		//行の削除
		var call_del_func = function(selector){
			var id = selector.data('id');
			var path = path_org+'mode=del&id='+id+'&val=1';
			$.get(path,function(data) {
				selector.parent().parent().remove();
				chk_num();	//数が足りてるかチェック
			});
		};

		//イベントのアペンド
		var append_enevt = function(){
			//期限の更新-メインルーチン
			$('.dke_kigen').change(function(){
				if(!$(this).val().match('[0-9][0-9][0-9][0-9]-[0-9][0-9]-[0-9][0-9]')){
					alert('日時はyyyy-mm-dd形式で書いて下さい');
					return false;
				}

				call_func('kigen',$(this));
			});

			//在庫の更新-メインルーチン
			$('.dke_zaiko').change(function(){
				call_func('zaiko',$(this));
			});

			//LOTの更新-メインルーチン
			$('.dke_lot').change(function(){
				call_func('lot',$(this));
			});

			//行の削除-メインルーチン
			$('.skt_del').click(function(){
				call_del_func($(this));
			});

		}

		//行の追加
		$('#skt_add').click(function(){
			var id = $(this).data('id');
			var path = path_org+'mode=new&id='+id+'&val=1';
			$.get(path,function(data) {
				//食品の時
				if($('#skt_total_zaiko').length){
					$('#syoumi_kigen_table').append('<tr><td><img class=\'skt_del\' data-id=\''+data+'\' src=\'https://www.tirakita.com/Gif/icons/gem_remove.png\'><input class=\'dke_kigen\' data-id=\''+data+'\' value=\'\'></td><td><input class=\'dke_zaiko\' data-id=\''+data+'\' value=\'0\'>個</td></tr>');
				}

				//自社輸入化粧品の時はLOTも記録
				if($('#cosme_skt_total_zaiko').length){
					$('#syoumi_kigen_table').append('<tr><td><img class=\'skt_del\' data-id=\''+data+'\' src=\'https://www.tirakita.com/Gif/icons/gem_remove.png\'><input class=\'dke_kigen\' data-id=\''+data+'\' value=\'\'></td><td><input class=\'dke_lot\' data-id=\''+data+'\' value=\'\'></td><td><input class=\'dke_zaiko\' data-id=\''+data+'\' value=\'0\'>個</td></tr>');
				}

				append_enevt();	//イベントの再アペンド
				chk_num();	//数が足りてるかチェック
			});
		});

		chk_num();	//数が足りてるかチェック
		append_enevt();	//イベントの最アペンド
	}

});
